import * as React from 'react';
import { Title, Select, Input, Button, Loader } from '../../modules/modules';
import { callAuthorizeBackend } from '../../helpers/backend/callAuthorizeBackend';
import CountryService from '../../services/CountryService';

interface IPriceListFormProps {
  currencyList: any;
}

interface IPriceListFormState {
  formValues?: any;
  errors?: any;
  generating: boolean;
}

class PriceListForm extends React.Component<IPriceListFormProps, IPriceListFormState> {
  public constructor(props: IPriceListFormProps) {
    super(props);

    this.state = {
      formValues: {
        Currency: CountryService.GetInstance().currencyCode,
      },
      errors: {},
      generating: false,
    };
  }

  public render() {
    const { currencyList } = this.props;
    const currencies = currencyList && !currencyList.loading ? currencyList.currencyList : null;

    return (
      <div className="priceList">
        <div className="form form--priceList">
          <div className="priceList__form">
            <Title type="sub">Price list</Title>

            {!currencies && <Loader />}

            {currencies && (
              <>
                <div>
                  {this.renderInput('Currency', 'Currency', {
                    type: 'select',
                    placeholder: 'Currency',
                    options: currencies.map((currency: GQL.ICurrency) => {
                      return { value: currency.value, label: currency.value };
                    }),
                    required: true,
                  })}
                </div>

                <div className="row">
                  <div className="col-sm-12 form__submit">
                    <Button
                      type="xl"
                      disabled={this.state.generating}
                      onClick={() => {
                        this.handleSend();
                      }}
                    >
                      Generate price list
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  private renderInput(name: string, label: string, options: any = {}) {
    const data = { ...this.state.formValues };

    let element: any = null;

    if (options.type && options.type === 'select') {
      element = (
        <Select
          name={name}
          label={label}
          placeholder={options.placeholder !== undefined ? options.placeholder : null}
          required={options.required !== undefined ? options.required === true : false}
          options={options.options || undefined}
          value={data[name] || options.defaultValue || ''}
          clearFilterDisabled={true}
          onChange={(e: any) => this.onChange({ target: { name, value: e.target.value.value } })}
        />
      );
    } else {
      element = (
        <Input
          type={options.type || 'text'}
          name={name}
          label={label}
          required={options.required !== undefined ? options.required === true : false}
          value={data[name] || ''}
          onChange={this.onChange}
        />
      );
    }

    const hasError = this.state.errors[name] === true;

    return (
      <div className={`form__item${hasError ? ' hasError' : ''}`}>
        {element}
        {this.state.errors[name] === true && <div className="form__error">Please enter value</div>}
      </div>
    );
  }

  private onChange(e: any) {
    const { name, value, checked } = e.target;

    const newValue = value !== undefined ? value : checked;

    this.setState({
      formValues: { ...this.state.formValues, [name]: newValue },
    });
  }

  private handleSend() {
    // volání backendu
    this.setState(
      {
        generating: true,
      },
      () => {
        callAuthorizeBackend({
          path: '/products/pricelist',
          data: {
            currency: this.state.formValues.Currency,
            vatRate: CountryService.GetInstance().VATrate,
          },
          method: 'POST',
          executeDownload: true,
          onSuccess: () => {
            this.setState({
              generating: false,
            });
          },
          onError: () => {
            this.setState({
              generating: false,
            });
          },
        });
      },
    );
  }
}

export default PriceListForm;



// WEBPACK FOOTER //
// ./src/components/PriceList/PriceList.tsx